import React from 'react';
import styles from './IFrame.module.scss';
import IFrameProps, { Scrolling } from './IFrame.types';

const IFrame = React.forwardRef<HTMLIFrameElement, IFrameProps>(
  (
    {
      url,
      sandbox,
      scrolling = Scrolling.No,
      height = 500,
      title = 'LiberisContractUI',
      dataCy = 'LiberisIFrame',
      dataTestid = 'LiberisIFrame',
    },
    ref
  ) => {
    return (
      <iframe
        title={title}
        src={url}
        ref={ref}
        height={height}
        data-cy={dataCy}
        data-testid={dataTestid}
        scrolling={scrolling}
        sandbox={sandbox}
        className={styles.container}
      />
    );
  }
);

export default IFrame;
